// Derive a darker action colour without changing the protected LDS brand tokens.
export default function accessibleBrand() {
    const probe = document.createElement('span');
    probe.style.color = 'var(--lds-ghost-brand-accent, #82a523)';
    probe.style.display = 'none';
    document.body.appendChild(probe);
    const colour = getComputedStyle(probe).color;
    probe.remove();
    const canvas = document.createElement('canvas');
    canvas.width = canvas.height = 1;
    const context = canvas.getContext('2d', {willReadFrequently: true});
    context.fillStyle = colour;
    context.fillRect(0, 0, 1, 1);
    const primary = Array.from(context.getImageData(0, 0, 1, 1).data).slice(0, 3);
    const luminance = rgb => rgb.map(v => v / 255).map(v => v <= .04045 ? v / 12.92 : ((v + .055) / 1.055) ** 2.4)
        .reduce((sum, v, i) => sum + v * [.2126, .7152, .0722][i], 0);
    // Aim above the normal-text minimum, including on the pale member surface.
    let factor = .7;
    let action;
    do {
        action = primary.map(v => Math.round(v * factor));
        factor -= .025;
    } while (1.05 / (luminance(action) + .05) < 7 && factor > 0);
    document.documentElement.style.setProperty('--lds-ghost-accessible-action', `rgb(${action.join(',')})`);
    const darkLink = primary.map(v => Math.round(v * .35 + 255 * .65));
    document.documentElement.style.setProperty('--lds-ghost-dark-link', `rgb(${darkLink.join(',')})`);
}
